import { GridCellProps } from '@progress/kendo-react-grid';
import { useCallback } from 'react';
import ExpandCollapseCell from 'src/components/custom-cells/ExpandCollapseCell';
import PopUp from 'src/components/design-system/PopUp';
import GridCellBase from 'src/components/GridCellBase';
import PopUpContentWrapper from 'src/components/PopUpContentWrapper';
import useViewBudgetPeriod from 'src/hooks/useViewBudgetPeriod';

const ExpandedCell = (props: GridCellProps) => {
  const { setBudgetPeriods, isBudgetPeriodDirty } = useViewBudgetPeriod();
  const { expanded = false } = props?.dataItem;
  const { dataItem } = props;

  const handleExpandClick = useCallback(() => {
    if (!isBudgetPeriodDirty) {
      setBudgetPeriods((prev) =>
        [...prev].map((period) =>
          period.rowId === dataItem.rowId ? { ...period, expanded: !period.expanded } : period
        )
      );
    }
  }, [dataItem.rowId, isBudgetPeriodDirty, setBudgetPeriods]);

  return (
    <GridCellBase {...props} className="k-hierarchy-cell" disableToolTip>
      <PopUp
        content={<PopUpContentWrapper type="Error" contents={['Save required']} />}
        show={isBudgetPeriodDirty}
      >
        <ExpandCollapseCell
          expand={expanded}
          onExpand={handleExpandClick}
          plusIconColor={isBudgetPeriodDirty ? '#aaa' : '#0e80b4'}
          minusIconColor={isBudgetPeriodDirty ? '#aaa' : '#0e80b4'}
        />
      </PopUp>
    </GridCellBase>
  );
};

export default ExpandedCell;
